import React, {useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import {red} from "@material-ui/core/colors";
import StyledContentLoader from 'styled-content-loader'
import {TextField} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {API} from "aws-amplify";
import {API_BASE_PATH} from "../../CommonUtilities/UtilityFunctions";

export const useStyles = makeStyles((theme) => ({
    failedStudents: {
        backgroundColor: red[100]
    }
}));

export default function StudentTableMetadata({studentDetails}) {
    const classes = useStyles();
    const [notesTesoreria, setNotesTesoreria] = useState("");
    const [currentInvoiceNeeded, setCurrentInvoiceNeeded] = useState(studentDetails?.invoiceNeeded || false);
    const [isUpdatingInvoiceStatus, setIsUpdatingInvoiceStatus] = useState(false);

    const handleToggleInvoiceNeeded = async () => {
        if (isUpdatingInvoiceStatus) {
            return; // Prevent multiple calls if already updating
        }

        const newInvoiceNeededState = !currentInvoiceNeeded;
        // Optimistically update UI, but it will be reverted on error by the existing logic
        setCurrentInvoiceNeeded(newInvoiceNeededState);
        setIsUpdatingInvoiceStatus(true);

        if (!studentDetails || !studentDetails.studentUuid) {
            console.error("Student UUID is missing, cannot update invoice status.");
            alert("Error: No se pudo identificar al estudiante para actualizar el estado de la factura.");
            setCurrentInvoiceNeeded(!newInvoiceNeededState); // Revert UI
            setIsUpdatingInvoiceStatus(false);
            return;
        }

        try {
            await API.put(API_BASE_PATH, `/students`, {
                body: {
                    studentUuid: studentDetails.studentUuid, 
                    invoiceNeeded: newInvoiceNeededState
                }
            });
            console.log(`Successfully updated invoiceNeeded to ${newInvoiceNeededState} for student ${studentDetails.studentUuid}`);
        } catch (e) {
            console.error("Failed to update invoice status:", e.message);
            alert("No se pudo actualizar el estado de la factura. Por favor, intente de nuevo.");
            setCurrentInvoiceNeeded(!newInvoiceNeededState); // Revert UI on failure
        } finally {
            setIsUpdatingInvoiceStatus(false);
        }
    };

    function saveNotesApi() {
        return API.put(API_BASE_PATH, `/students`, {
            body: {studentUuid: studentDetails.studentUuid, notesTesoreria: notesTesoreria}
        });
    }

    async function saveNotes() {
        if (!studentDetails.studentUuid) {
            alert("No se pueden gardar las notas");
            return;
        }
        try {
            await saveNotesApi();
        } catch (e) {
            console.log(e.message);
            alert("No se pudo guardar las notas de tesorería, por favor intente de nuevo");
        }
    }

    useEffect(() => {
        setNotesTesoreria(studentDetails?.notesTesoreria || "");
        setCurrentInvoiceNeeded(studentDetails?.invoiceNeeded || false);
        // Reset loading state if studentDetails changes, though unlikely to be an issue here
        setIsUpdatingInvoiceStatus(false);
    }, [studentDetails]);

    // Extract TextField and add it as a component
    return (
        <div>
            {studentDetails ?
                <div>
                    <StyledContentLoader isLoading={studentDetails.studentId ? false : true}>
                        <Typography variant="h4" component="h2" style={{ display: 'flex', alignItems: 'center' }}>
                            {studentDetails?.name ? studentDetails.name : ""}
                            <IconButton
                                color={currentInvoiceNeeded ? "primary" : "default"}
                                aria-label="toggle invoice needed"
                                onClick={handleToggleInvoiceNeeded}
                                style={{ marginLeft: '10px' }}
                                disabled={isUpdatingInvoiceStatus}
                            >
                                {currentInvoiceNeeded ? <CheckCircleIcon /> : <HighlightOffIcon />}
                            </IconButton>
                        </Typography>
                        <Typography variant="h5" component="h2">
                            {studentDetails.studentId} {studentDetails.major} {studentDetails.cuatrimestre}{studentDetails.group}
                        </Typography>
                        <Typography variant="h5" component="h2">
                            CURP: {studentDetails.curp}
                        </Typography>
                        <Typography variant="h5" component="h2">
                            PROMEDIO: {studentDetails.average}
                        </Typography>
                        <Typography variant="h5" component="h2" className={classes.failedStudents}>
                            Materias Reprobadas: {studentDetails.numberOfFailedTopics}
                        </Typography>
                        <TextField label="Notas Tesorería"
                                   style={{width: '85%'}}
                                   value={notesTesoreria}
                                   onChange={e => setNotesTesoreria(e.target.value)}
                        />
                        <Button
                            // variant="contained"
                            color="primary"
                            // className={buttonClassname}
                            onClick={saveNotes}
                        >
                            Guardar Notas
                        </Button>

                    </StyledContentLoader>
                </div>
                : <></>}
        </div>
    );
}